import "./index.css";
import React from "react";
import { Button, Spin, Tooltip } from "antd";
import Copy from "MortgageGPT/components/Contact/Copy";

interface TypeWebsiteInfoProps extends Record<"icon" | "title", string> {
  url?: string;
  onEdit?(): void;
  /**
   * @param loading 是否正在更新状态
   */
  loading: boolean;
  /**
   * Extra class for a specific surface, e.g. `bluerate`.
   */
  className?: string;
  /**
   * 已选择组织时展示的说明，例如 Managed in GMCC — San Jose
   */
  description?: React.ReactNode;
  /**
   * 点击说明文案（例如切换到 managed-in 组织）
   */
  onDescriptionClick?(): void;
  /**
   * Hover explanation for the description action, e.g. why a new org is needed.
   */
  descriptionTooltip?: React.ReactNode;
  /**
   * Force the card to span the full row, even without a URL.
   */
  fullWidth?: boolean;
}

const STYLE_NOT_FULL = {
  marginRight: 10,
  width: `calc(50% - 5px)`,
  display: "inline-block",
};

/**
 * @name WebsiteInfo 个人主页信息
 */
const WebsiteInfo: React.FC<TypeWebsiteInfoProps> = ({
  url,
  icon,
  title,
  loading,
  children,
  className,
  description,
  onDescriptionClick,
  descriptionTooltip,
  fullWidth,
}) => (
  <div
    className={["website-info-item", className].filter(Boolean).join(" ")}
    style={fullWidth || url || description ? { width: "100%" } : STYLE_NOT_FULL}
  >
    <div>
      <div>
        <img draggable="false" src={icon} alt="#" />
      </div>
      <div>
        <p>
          {title}
          {loading ? (
            <Tooltip title="Available when data synchronization is complete, please wait">
              <Spin size="small" spinning />
            </Tooltip>
          ) : null}
        </p>
        {description ? (
          onDescriptionClick ? (
            <Tooltip title={descriptionTooltip || undefined} placement="topLeft">
              <Button
                type="link"
                className="website-info-org-action"
                onClick={onDescriptionClick}
              >
                {description}
              </Button>
            </Tooltip>
          ) : (
            <p className="website-info-org">{description}</p>
          )
        ) : null}
        {url ? (
          <p className="website-info-link">
            <a href={url} target="_blank">
              {url}
            </a>
            <Copy text={url} />
            {children}
          </p>
        ) : null}
      </div>
    </div>
  </div>
);

export default WebsiteInfo;
